import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { SocialModule } from '@tytapp/social';
import { TYTCommonModule } from '@tytapp/common';
import { AnnouncementsBlockComponent, CommonUiModule, PlusAdBlockComponent } from '@tytapp/common-ui';
import { HomeComponent } from './home/home.component';
import { FreeAccountBenefitsComponent } from './free-account-benefits/free-account-benefits.component';
import { PollsModule } from '@tytapp/polls';
import { UserModule } from '@tytapp/user';
import { HomeCardComponent } from '@tytapp/app/pages/home-page/home-card/home-card.component';
import { HomeCardComponentHost } from '@tytapp/app/pages/home-page/home-card-component-host.component';
import { DefaultHomeCardComponent } from '@tytapp/app/pages/home-page/default-home-card.component';
import { HomeCardsService } from '@tytapp/app/pages/home-page/home-cards.service';
import { NewsletterComponent } from '@tytapp/common-ui/newsletter-module/newsletter-module.component';
import { WatchOnComponent } from '@tytapp/app/pages/home-page/watch-on/watch-on.component';
import { FeaturedCardPollComponent } from '@tytapp/app/pages/home-page/featured-poll-card/featured-card-poll.component';
import { TopicCardComponent } from '@tytapp/app/pages/home-page/topic-card/topic-card.component';
import { environment } from '@tytapp/environment';
import { MissionLeaderboardComponent } from '@tytapp/app/pages/home-page/mission-leaderboard/mission-leaderboard.component';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ArticleCardComponent } from './article-card/article-card.component';
import { EmbeddedOfferSetComponent } from '@tytapp/common-ui/embedded-offer-set/embedded-offer-set.component';
import { DiscordCardComponent } from '@tytapp/app/pages/home-page/discord-card/discord-card.component';
import { RecommendedPollsCardComponent } from '@tytapp/app/pages/home-page/recommended-polls-card/recommended-polls-card.component';
import { LiveStreamsModule } from '@tytapp/live-streams';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { ChatModule } from '@tytapp/chat';
import { DevModule } from '@tytapp/app/dev';
import { TodaysLiveScheduleComponent } from '@tytapp/live-ui';
import { MediaUiModule } from '@tytapp/media-ui';
import { ContentModule } from '@tytapp/content';
import { ForumPostsComponent } from '@tytapp/community';

@NgModule({
    declarations: [
        FreeAccountBenefitsComponent,
        HomeCardComponent,
        HomeCardComponentHost,
        DefaultHomeCardComponent,
        WatchOnComponent,
        FeaturedCardPollComponent,
        TopicCardComponent,
        MissionLeaderboardComponent,
        ArticleCardComponent,
        DiscordCardComponent,
        RecommendedPollsCardComponent,
        HomeComponent
    ],
    providers: [
        HomeCardsService
    ],
    imports: [
        CommonModule,
        FormsModule,
        TYTCommonModule,
        CommonUiModule,
        MediaUiModule,
        ContentModule,
        UserModule,
        PollsModule,
        MediaPlaybackModule,
        ChatModule,
        DevModule,
        LiveStreamsModule,
        MatButtonModule,
        RouterModule,
        MatIconModule,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        SocialModule,
        RouterModule.forChild([
            {
                path: '',
                component: HomeComponent
            }
        ])
    ]
})
export class HomePageModule {
    homeCards = inject(HomeCardsService);

    constructor() {
        this.homeCards.register({ type: DefaultHomeCardComponent, devToolsLabel: 'Unimplemented Card' });
        //this.homeCards.register({ type: FeaturedMembersComponent, devToolsLabel: 'Featured Members' });


        this.homeCards.register({
            id: 'signup_c2a',
            devToolsLabel: 'Signup call to action',
            type: PlusAdBlockComponent,
            parameters: {
                fullBleed: true
            }
        });

        this.homeCards.register({
            id: 'latest_community_forum_posts',
            devToolsLabel: 'Community: Latest',
            type: ForumPostsComponent,
            parameters: {
                sort: 'latest',
                title: '<span class="hope-tag">Latest</span> Community',
                icon: { type: 'material', text: 'notifications_active' },
                more: { url: environment.urls.forums, newTab: true }
            }
        });

        this.homeCards.register({
            id: 'top_community_forum_posts',
            type: ForumPostsComponent,
            devToolsLabel: 'Community: Popular',
            parameters: {
                sort: 'top',
                title: '<span class="hope-tag">Popular</span> Community',
                icon: { type: 'material', text: 'groups' },
                more: { url: environment.urls.forums, newTab: true }
            }
        });

        this.homeCards.register({
            id: 'latest_operation_hope_posts',
            devToolsLabel: 'Operation Hope: Latest',
            type: ForumPostsComponent,
            parameters: {
                sort: 'latest',
                category: 'operation_hope',
                title: '<span class="hope-tag">Latest</span> <img class="operation-hope-logo" src="/assets/operation-hope/operation-hope-logo-v2.svg" alt="Operation: Hope" />',
                icon: { type: 'material', text: 'notifications_active' },
                more: { url: environment.urls.forums, newTab: true }
            }
        });

        this.homeCards.register({
            id: 'top_operation_hope_posts',
            type: ForumPostsComponent,
            devToolsLabel: 'Operation Hope: Popular',
            parameters: {
                sort: 'top',
                category: 'operation_hope',
                title: '<span class="hope-tag">Popular</span> <img class="operation-hope-logo" src="/assets/operation-hope/operation-hope-logo-v2.svg" alt="Operation: Hope" />',
                icon: { type: 'material', text: 'groups' },
                more: { url: environment.urls.forums, newTab: true }
            }
        });

        this.homeCards.register({
            id: 'newsletter',
            type: NewsletterComponent,
            devToolsLabel: 'Newsletter Signup C2A',
            parameters: {
                title: 'Newsletter',
                icon: { type: 'image', url: '/assets/icons-2019/newsletters.svg' }
            }
        });
        this.homeCards.register({
            id: 'announcements',
            type: AnnouncementsBlockComponent,
            devToolsLabel: 'Announcements',
            parameters: {
                title: 'Announcements',
                icon: { type: 'image', url: '/assets/icons-2019/topics.svg' },
                more: { url: '/about/announcement' },
                quantity: 5,
                showHeader: false
            }
        });
        this.homeCards.register({
            id: 'tune_in',
            devToolsLabel: 'Watch On Your TV',
            type: WatchOnComponent
        });
        this.homeCards.register({
            id: 'live_schedule',
            devToolsLabel: 'Live Schedule',
            type: TodaysLiveScheduleComponent
        })
        this.homeCards.register({
            id: 'poll',
            devToolsLabel: 'Featured Poll (Needs `poll` in card)',
            type: FeaturedCardPollComponent,
            parameters: {
                expectedType: 'ChooseOnePoll'
            }
        });
        this.homeCards.register({
            id: 'petition',
            devToolsLabel: 'Featured Petition (Needs `petition` in card)',
            type: FeaturedCardPollComponent,
            parameters: {
                expectedType: 'Petition'
            }
        });
        // this.homeCards.register({
        //     id: 'plus',
        //     devToolsLabel: 'Support This Community',
        //     type: HomeSupportC2AComponent
        // });
        this.homeCards.register({
            id: 'topic',
            devToolsLabel: 'Topic (Needs `topic`/`topic_items` in card)',
            type: TopicCardComponent
        });
        this.homeCards.register({
            id: 'must_see',
            devToolsLabel: 'Must See (Needs `topic`/`topic_items` in card)',
            type: TopicCardComponent
        });
        this.homeCards.register({
            id: 'mission_leaderboard',
            devToolsLabel: 'Mission Leaderboard',
            type: MissionLeaderboardComponent
        });
        this.homeCards.register({
            id: 'today_on_tyt',
            devToolsLabel: 'TYT Voices',
            type: ArticleCardComponent,
            parameters: {
                franchiseSlug: 'tyt-voices',
                showFranchises: true,
                title: 'TYT Voices'
            }
        });
        this.homeCards.register({
            id: 'community_projects',
            devToolsLabel: 'Community Projects',
            type: ArticleCardComponent,
            parameters: {
                franchiseSlug: 'community-projects',
                showFranchises: false,
                count: 2,
                title: 'Community Projects'
            }
        });
        this.homeCards.register({
            id: 'featured_report',
            devToolsLabel: 'Featured Report',
            type: ArticleCardComponent,
            parameters: {
                mode: 'featured',
                showFranchises: true,
                title: 'TYT Reports'
            }
        });
        this.homeCards.register({
            id: 'offer_set',
            devToolsLabel: 'Offer Set',
            type: EmbeddedOfferSetComponent,
            parameters: {
                fullBleed: true
            }
        });
        this.homeCards.register({
            id: 'discord',
            devToolsLabel: 'Discord',
            type: DiscordCardComponent,
            parameters: {
                fullBleed: true
            }
        });

        this.homeCards.register({
            id: 'recommended_polls',
            devToolsLabel: 'Recommended Polls',
            type: RecommendedPollsCardComponent
        });

        // this.homeCards.register({
        //     id: 'continue_watching',
        //     devToolsLabel: 'Continue Watching',
        //     type: ContinueWatchingComponent
        // });
    }
}
